declare const __BUILD_COMMIT_ID__: string;

function normalizeBuildCommitId(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

export function getBuildCommitId(): string | null {
  return normalizeBuildCommitId(typeof __BUILD_COMMIT_ID__ === 'string' ? __BUILD_COMMIT_ID__ : null);
}

export function buildGeneratedShaderHeader(commentPrefix: string): string {
  const commitId = getBuildCommitId() ?? 'unknown';
  return `${commentPrefix} Generated by LUT Chainer\n${commentPrefix} Build commit: ${commitId}`;
}
